export enum AtiraLinkLang {
  AR = 'AR',
  EN = 'EN',
  TR = 'TR',
}
